<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 mx-0">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="message" isMandatory :disabled="mode === 'details' && editMode === false"
            :inputLabel="$t('common.routing.message')" :placeholderValue="$t('common.routing.message')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
            :inputLabel="$t('common.routing.receiver_id')" :placeholderValue="$t('common.routing.receiver_id')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <label>
            {{ $t('common.routing.format_name') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="idFormat" readonly :class="selectFormatColor" :disabled="mode === 'details' && editMode === false">
            <option value="null" disabled hidden> {{ $t('common.routing.select_format') }} </option>
            <option class="color-black-message-details" v-for="(item, index) in formatList" :key="index" :value="item.IdFormat">{{item.Name}}</option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group">
          <label>
            {{ $t('common.routing.config_type') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="configType" readonly :class="selectTypeColor" @change="onChangeConfigType" :disabled="mode === 'details' && editMode === false">
            <option value="null" hidden disabled> {{ $t('common.routing.select_config_type') }} </option>
            <option value="INTERPROCESS" class="color-black-message-details" > {{ $t('common.routing.inter_process') }} </option>
            <option value="MQSERIES" class="color-black-message-details" > {{ $t('common.routing.mqseries') }} </option>
            <option value="REMOTEFOLDER" class="color-black-message-details" > {{ $t('common.routing.remote_folder') }} </option>
            <option value="WEBSERVICE" class="color-black-message-details" > {{ $t('common.routing.web_service') }} </option>
            <option value="KAFKA" class="color-black-message-details" > {{ $t('common.routing.kafka') }} </option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group" v-if="isInterProcess">
          <label>
            {{ $t('common.routing.config_name') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="configInterProcessId" readonly :class="selectInterProcessColor" :disabled="mode === 'details' && editMode === false">
            <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
            <option class="color-black-message-details" v-for="(item, index) in interProcessList" :key="index" :value="item.IdInterProcess" >{{item.Name}}</option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group" v-if="isMQSeries">
          <label>
            {{ $t('common.routing.config_name') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="configMQSeriesId" readonly :class="selectMQSeriesColor" :disabled="mode === 'details' && editMode === false">
            <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
            <option class="color-black-message-details" v-for="(item, index) in mqseriesList" :key="index" :value="item.IdMQSeries" >{{item.Name}}</option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group" v-if="isRemoteFolder">
          <label>
            {{ $t('common.routing.config_name') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="configRemoteFolderId" readonly :class="selectRemoteFolderColor" :disabled="mode === 'details' && editMode === false">
            <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
            <option class="color-black-message-details" v-for="(item, index) in remoteFolderList" :key="index" :value="item.IdRemoteFolder" >{{item.Name}}</option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group" v-if="isWebService">
          <label>
            {{ $t('common.routing.config_name') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="configWebServiceId" readonly :class="selectWebServiceColor" :disabled="mode === 'details' && editMode === false">
            <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
            <option class="color-black-message-details" v-for="(item, index) in webServiceList" :key="index" :value="item.IdWebService" >{{item.Name}}</option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group" v-if="isKafka">
          <label>
            {{ $t('common.routing.config_name') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="configKafkaId" readonly :class="selectWebServiceColor" :disabled="mode === 'details' && editMode === false">
            <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
            <option class="color-black-message-details" v-for="(item, index) in kafkaList" :key="index" :value="item.idConfigKafka" >{{item.name}}</option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group">
          <label>
            {{ $t('common.routing.standard') }}<span class="color-red"> * </span>
          </label>
          <select class="form-control" v-model="idStandard" readonly :class="selectFormatColor" :disabled="mode === 'details' && editMode === false">
            <option value="null" disabled hidden> {{ $t('common.routing.select_standard') }} </option>
            <option class="color-black-message-details" v-for="(item, index) in standardList" :key="index" :value="item.IdStandard">{{item.Name}}</option>
          </select>
        </b-col>
      </b-row>
      <b-row class="justify-content-end mt-3 no-gutters">
        <b-button v-if="mode === 'create'"
        @click="createMessageRouting" variant="primary">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button v-if="mode === 'details' && editMode === false && canEditMessage" class="mr-3"
        @click="editModeActivate" variant="primary">
          <span>{{$t('common.routing.edit_this_message')}}</span>
        </b-button>
        <b-button v-if="mode === 'details' && editMode === false && canDeleteMessage"
        @click="deleteMessageRouting" variant="primary">
          <i class="fa-light fa-trash"></i>
          <span>{{$t('common.routing.delete_message')}}</span>
        </b-button>
        <b-button variant="primary" v-if="mode === 'details' && editMode === true"
          @click="editMessageRouting">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'

import {loadPage} from '@/helpers/routing'

export default {
  name: 'MessageDetails',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    role: {
      type: String,
      default: "0"
    },
  },
  computed: {
    canDeleteMessage () {
      return this.$engine.rights.rightIs('messageRoutingConfig_supprimer', true)
    },
    canEditMessage () {
      return this.$engine.rights.rightIs('messageRoutingConfig_editer', true)
    },
    configId () {
      if (this.configType === "INTERPROCESS") {
        return this.configInterProcessId
      } else if (this.configType === "MQSERIES") {
        return this.configMQSeriesId
      } else if (this.configType === "REMOTEFOLDER") {
        return this.configRemoteFolderId
      } else {
        return this.configWebServiceId
      }
    },
    isInterProcess () {
      return this.configType === "INTERPROCESS" ? true : false
    },
    isKafka () {
      return this.configType === "KAFKA" ? true : false
    },
    isMQSeries () {
      return this.configType === "MQSERIES" ? true : false
    },
    isRemoteFolder () {
      return this.configType === "REMOTEFOLDER" ? true : false
    },
    isWebService () {
      return this.configType === "WEBSERVICE" ? true : false
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.message_details') : this.$t('Webheader.message_add')
    },
    selectFormatColor () {
      return this.idFormat === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectInterProcessColor () {
      return this.configInterProcessId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectMQSeriesColor () {
      return this.configMQSeriesId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectRemoteFolderColor () {
      return this.configRemoteFolderId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectTypeColor () {
      return this.configType === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectWebServiceColor () {
      return this.configWebServiceId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    }
  },
  data () {
    return {
      activateSpinner: false,
      configInterProcessId: 'null',
      configKafkaId: 'null',
      configMQSeriesId: 'null',
      configRemoteFolderId: 'null',
      configType: 'null',
      configWebServiceId: 'null',
      editMode: false,
      idFormat: 'null',
      idStandard: 'null',
      formatList: [],
      interProcessList: [],
      kafkaList: [],
      message: '',
      mqseriesList: [],
      receiverId: '',
      remoteFolderList: [],
      returnUrl: '/routing/messageList/' + this.role,
      savedMessage: [],
      standardList: [{
        IdStandard: 1,
        Name:this.$t('common.norm.srtp')
      },{
        IdStandard: 2,
        Name: this.$t('common.norm.giro')
      },{
        IdStandard: 3,
        Name: this.$t('common.norm.psd2')
      }],
      webServiceList: []
    }
  },
  created () {
    this.activateSpinner = true

    this.getFormat()

    if (this.mode === "details") {
      this.savedMessage = this.$engine.routing.message.clickedMessage
      this.fillFields()
      this.$engine.routing.message.clickedMessage = {}
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
    createMessageRouting () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Role: this.role,
        Message: this.message,
        ReceiverId: this.receiverId,
        IdFormat: this.idFormat,
        IdConfig: this.configId,
        RoutingType: this.configType,
        Standard: this.idStandard
      }
      this.$engine.routing.message.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.message_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/messageList/' + that.role})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.message_addition_error'))
      })
    },
    deleteMessageRouting () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.message_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdMessageRouting: that.savedMessage.IdMessageRouting
              }
              that.$engine.routing.message.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.message_deleted'))
                loadPage(that, {url: '/routing/messageList/' + that.role})
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editMessageRouting () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Role: this.role,
        Message: this.message,
        ReceiverId: this.receiverId,
        IdFormat: this.idFormat,
        IdConfig: this.configId,
        RoutingType: this.configType,
        IdMessageRouting: this.savedMessage.IdMessageRouting,
        Standard: this.idStandard
      }
      this.$engine.routing.message.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.message_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/messageList/' + that.role})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.message_edition_error'))
      })
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.message = this.savedMessage.Message
      this.receiverId = this.savedMessage.ReceiverId
      this.idFormat = this.savedMessage.IdFormat
      this.configType = this.savedMessage.ConfigType
      this.idStandard = this.savedMessage.Standard

      if (this.configType === "INTERPROCESS") {
        this.getInterProcessConfigs()
        this.configInterProcessId = this.savedMessage.IdConfig
      }
      if (this.configType === "MQSERIES") {
        this.getMQSeriesConfigs()
        this.configMQSeriesId = this.savedMessage.IdConfig
      }
      if (this.configType === "REMOTEFOLDER") {
        this.getRemoteFolderConfigs()
        this.configRemoteFolderId = this.savedMessage.IdConfig
      }
      if (this.configType === "WEBSERVICE") {
        this.getWebServiceConfigs()
        this.configWebServiceId = this.savedMessage.IdConfig
      }
      if (this.configType === 'KAFKA') {
        this.getKafkaConfigs()
        this.configKafkaId = this.savedMessage.IdConfig
      }
    },
    formHasError () {
      if (this.message.length === 0) {
        this.okMessageBox(this.$t('common.routing.message_type_missing'))
        return true
      }
      if (this.receiverId.length === 0) {
        this.okMessageBox(this.$t('common.routing.receiver_id_missing'))
        return true
      }
      if (this.idFormat === "null") {
        this.okMessageBox(this.$t('common.routing.format_name_missing'))
        return true
      }
      if (this.configType === "null") {
        this.okMessageBox(this.$t('common.routing.config_type_missing'))
        return true
      }
      if (this.configId === "null") {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if (this.idStandard === "null") {
        this.okMessageBox(this.$t('common.routing.standard_name_missing'))
        return true
      }
      return false
    },
    getFormat () {
      this.$engine.routing.format.fetch(
        {}
      ).then(resp => {
        this.formatList = resp.data.Formats

        this.$f7.pullToRefreshDone()
      })
    },
    getInterProcessConfigs () {
      this.$engine.routing.config.interProcess.fetch(
        {}
      ).then(resp => {
        this.interProcessList = resp.data.InterProcesses

        this.$f7.pullToRefreshDone()
      })
    },
    getMQSeriesConfigs () {
      this.$engine.routing.config.mqseries.fetch(
        {}
      ).then(resp => {
        this.mqseriesList = resp.data.MQSeries

        this.$f7.pullToRefreshDone()
      })
    },
    getRemoteFolderConfigs () {
      this.$engine.routing.config.remoteFolder.fetch(
        {}
      ).then(resp => {
        this.remoteFolderList = resp.data.RemoteFolder

        this.$f7.pullToRefreshDone()
      })
    },
    getWebServiceConfigs () {
      this.$engine.routing.config.webService.fetch(
        {}
      ).then(resp => {
        this.webServiceList = resp.data.WebService

        this.$f7.pullToRefreshDone()
      })
    },
    getKafkaConfigs () {
      this.$engine.routing.config.kafka.fetch(
        {}
      ).then(resp => {
        this.kafkaList = resp.data.configKafka

        this.$f7.pullToRefreshDone()
      })
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: '/routing/messageList/' + this.role})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onChangeConfigType () {
      if (this.configType === "INTERPROCESS") {
        this.getInterProcessConfigs()
      } else if (this.configType === "MQSERIES") {
        this.getMQSeriesConfigs()
      } else if (this.configType === "REMOTEFOLDER") {
        this.getRemoteFolderConfigs()
      } else if (this.configType === "WEBSERVICE") {
        this.getWebServiceConfigs()
      } else if (this.configType === 'KAFKA') {
        this.getKafkaConfigs()
      }

      if (this.configType !== "INTERPROCESS") {
        this.configInterProcessId = "null"
      }
      if (this.configType !== "KAFKA") {
        this.configKafkaId = "null"
      }
      if (this.configType !== "MQSERIES") {
        this.configMQSeriesId = "null"
      }
      if (this.configType !== "REMOTEFOLDER") {
        this.configRemoteFolderId = "null"
      }
      if (this.configType !== "WEBSERVICE") {
        this.configWebServiceId = "null"
      }
    }
  }
}
</script>
